class geoDealers {
	constructor() {
		// localStorage.removeItem('userAddress');
		var userAddress = localStorage.getItem('userAddress');

		if ($('.find-dealer-submit').length) {
			var addrVal = $('.find-dealer-submit').parents('form').find('.geolocation').val();
			if (addrVal != '') {
				userAddress = addrVal;
			}
		}

		this.initGeo(userAddress);
		this.runGeo = true;
	}

	initGeo(userAddress) {
		var _this = this;
		// If there is no address cached - find the address
 		if (!userAddress || userAddress =='' || typeof userAddress == undefined || userAddress == null) {
			this.addressLookUp(function() {
				userAddress = localStorage.getItem('userAddress');

				_this.dealersProcess(userAddress);
		
			});
		// If there is an address cached
 		} else {
 			// var formExists = setInterval(geo.dealersProcess(userAddress, formExists), 100);
 			console.log(userAddress + ' - Address found!');
 			$(document).ready(function() {
 				console.log('Ready...');
 				// $(document).on('nfFormReady', function ( e, layoutView ) {
 				// 	console.log('Form is ready');
 					_this.dealersProcess(userAddress);
 				// });
 			});
 			
 		}
	}

	// Dealers Process: Steps to load dealers and assign correct values to geo inputs 
	dealersProcess (userAddress) {
		var _this = this;

	    if (typeof google === "undefined" || !google.maps) {
	        // Try again in 500ms until Google loads
	        setTimeout(function() {
	            _this.dealersProcess(userAddress);
	        }, 500);
	        return;
	    }

		if ($(".nf-form-layout").length > 0) {
			if ($('.geolocation').length > 0) {

			    const bounds = new google.maps.LatLngBounds(
			        new google.maps.LatLng(24.396308, -125.0),
			        new google.maps.LatLng(49.384358, -66.93457)
			    );

			    $('.geolocation').each(function () {

			        const input = this;

			        const autocomplete = new google.maps.places.Autocomplete(input, {
			            bounds: bounds,
			            strictBounds: false,
			            componentRestrictions: {
			                country: ['us', 'ca']
			            },
			            fields: [
			                'address_components',
			                'formatted_address',
			                'geometry'
			            ],
			            types: ['address']
			        });

			        let enterPressed = false;

			        /*
			         * Desktop keyboard support
			         */
			        $(input).on('keydown', function (e) {

			            if (e.key === 'Enter') {

			                // Don't let the form submit before Google
			                // has a chance to process the selection.
			                e.preventDefault();

			                enterPressed = true;

			                // Allow your existing form logic to run.
			                $(this).trigger('change');
			            }
			        });

			        /*
			         * Google selection
			         *
			         * This is also what handles mobile users
			         * tapping a prediction.
			         */
			        autocomplete.addListener('place_changed', function () {

			            const place = autocomplete.getPlace();

			            if (!place || !place.address_components) {
			                enterPressed = false;
			                return;
			            }

			            const country = place.address_components.find(function (component) {
			                return component.types.includes('country');
			            });

			            if (
			                !country ||
			                !['US', 'CA'].includes(country.short_name)
			            ) {
			                console.log('Rejected non-US/CA result');
			                enterPressed = false;
			                return;
			            }

			            /*
			             * A valid Google prediction was selected.
			             */
			            if (place.formatted_address) {

			                $(input)
			                    .val(place.formatted_address)
			                    .trigger('change');

			                /*
			                 * Trigger native change event for
			                 * Ninja Forms / other handlers.
			                 */
			                const evt = new Event('change', {
			                    bubbles: true,
			                    cancelable: true
			                });

			                input.dispatchEvent(evt);
			            }

			            enterPressed = false;
			        });

			    });

			    _this.assignAddressToInput(userAddress);

			    /*
			     * Find Dealers Page
			     */
			    $('.geolocation').each(function (index, el) {

			        const $form = $(el).parents('.nf-form-content');
			        const $slider = $form.find('[data-load-dealers]');

			        const formID = $form.parents('.block-find-dealer').length
			            ? $form.parents('.block-find-dealer').data('form-id')
			            : $form.find('.block-find-dealer').data('form-id');

			        if (
			            $form.find('.find-dealer-submit').length > 0 ||
			            $slider.length > 0
			        ) {

			            const storedPoint = localStorage.getItem('userLatLng');
			            const point = storedPoint
			                ? JSON.parse(storedPoint)
			                : null;

			            const number = $slider.length > 0
			                ? $slider.data('dealers-number')
			                : -1;

			            const dealersNumber =
			                $form.parents('.dealer-content').data('dealers-number');

			            const threshold =
			                $form.parents('[data-threshold]').length
			                    ? $form.parents('.dealer-content').data('threshold')
			                    : $form.find('[data-threshold]').data('threshold');

			            const wrapper =
			                $form.parents('#find-dealer-form').length > 0
			                    ? false
			                    : true;

			            _this.loadDealers(
			                formID,
			                point,
			                number,
			                dealersNumber,
			                threshold,
			                wrapper
			            );

			        } else {

			            // Needed for partial leads
			            const storedPoint = localStorage.getItem('userLatLng');
			            const point = storedPoint
			                ? JSON.parse(storedPoint)
			                : null;

			            _this.matchDealertoAddress(point);
			        }
			    });
			}
		  
		} else {
			setTimeout(function() {_this.dealersProcess(userAddress)}, 1000);
		}
	}

	// Find Current User Address - first time only, if there is no cached value
	addressLookUp(callback) {
 	    $.ajax({
 	        type : 'POST',
 	        data: JSON.stringify({
 	            considerIp: true
 	          }), 
 	        url: "https://www.googleapis.com/geolocation/v1/geolocate?key=" + googleAPI, 
 	        success: function(result){
 	            var latitude = result['location']['lat'];
 	            var longitude = result['location']['lng'];
 	            var point = { lat: latitude, lng: longitude };
 	            var userAddress;

 	            new google.maps.Geocoder().geocode({ location : point }, function (res, status) {
 	                if (status == google.maps.GeocoderStatus.OK && typeof res[0] !== 'undefined') {
 	                    
 	                    for(var elmIdx in res)
	 	             	{
     		             	if(res[elmIdx].formatted_address.length > 0 && res[elmIdx].types.indexOf("plus_code") == -1)
     		             	{
     			             	userAddress = res[elmIdx].formatted_address;
     			             	break;
     		             	}
	 	             	}
	             		localStorage.setItem('userAddress', userAddress);
	             		localStorage.setItem('userLatLng', JSON.stringify(point));

	             		console.log(localStorage.getItem('userAddress'));

	             		// Assign New Values to inputs and save primary dealer
	             		callback();
	 	                
	 	            } else {
	 	                console.log('Google maps error: ' + status + '. Please try again later.');
	 	            }
 	                    
 	            });

 	        }, 
 	        error: function(xhr, status, error) {
 	        	var err = JSON.parse(xhr.responseText);
 	            console.log('Unable to find your location. Ajax error. ' + err + ' | ' + status + ' | ' + error);
 	        }
 	    });
	}

	// Find user's coordinates based on the address input
	geocodeUserAddress(userAddress, loadDealers = true) {

	    if (!userAddress || !window.google?.maps?.Geocoder) {
	        return;
	    }

	    const geocoder = new google.maps.Geocoder();
	    const self = this;

	    geocoder.geocode({
	        address: userAddress
	    }, (results, status) => {

	        if (status !== google.maps.GeocoderStatus.OK || !results?.length) {
                return;
            }

            const result = results[0];

            const country = result.address_components.find(c =>
                c.types.includes('country')
            );

            if (!country || !['US', 'CA'].includes(country.short_name)) {
                console.warn('Rejected non US/CA result');
                return;
            }

	        const location = result.geometry.location;
            const point = {
                lat: location.lat(),
                lng: location.lng()
            };

            const formattedAddress = result.formatted_address;

            localStorage.setItem('userAddress', formattedAddress);
            localStorage.setItem('userLatLng', JSON.stringify(point));

            self.runGeo = false;

            $('.geolocation')
                .val(formattedAddress)
                .trigger('change');

            self.matchDealertoAddress(point);

            if (!loadDealers) return;

            $('.geolocation').each(function(index, el) {
            	const $form = $(el).parents('.nf-form-content');
            	const $slider = $form.find('[data-load-dealers]');
            	const formID = $form.parents('.block-find-dealer').length ? $form.parents('.block-find-dealer').data('form-id') : $form.find('.block-find-dealer').data('form-id');

            	if ($form.find('.find-dealer-submit').length > 0 || $slider.length > 0) {
            		var point = JSON.parse(localStorage.getItem('userLatLng'));
            		var number = $slider.length > 0 ? $slider.data('dealers-number') : -1; // Load only 3 dealers for single product template
            		var dealersNumber = $form.parents('.dealer-content').data('dealers-number');
            		var threshold = $form.parents('[data-threshold]').length ? $form.parents('.dealer-content').data('threshold') : $form.find('[data-threshold]').data('threshold');
            		var wrapper = $form.parents('#find-dealer-form').length > 0 ? false : true;

            		self.loadDealers(formID, point, number, dealersNumber, threshold, wrapper);
            	}
            });
	    });
	}


	// Find an input with class .geolocation and assign user postal code
	assignAddressToInput(userAddress) {
		var input = $('.geolocation')[0];
      	$('.geolocation').val(userAddress).trigger( 'change' );
	    // trigger event change the hard way - no other way works!!!
	    var evt = document.createEvent("HTMLEvents");
	    evt.initEvent("change", true, true);
	    $('.geolocation').each(function() {
	      this.dispatchEvent(evt);
	    });
	}


	// Find all dealers associated with user address
	loadDealers(formID, point, number = -1, dealersNumber = -1, threshold = 0, wrapper = false) {

		$.ajax({
		  method: 'POST',
		  url: ajax_url,
		  type: 'JSON',
		  data: {
		    point: point,
		    number: number,
		    dealers_number : dealersNumber,
		    threshold : threshold,
		    wrapper : wrapper,
		    action: 'load_dealers',
		  },
		  success: res => this.renderDealers(res, formID),
		  error: function (request, status, error) {
		          console.log(request.responseText);
		      }
		});
	}

	// Display dealers' HTML
	renderDealers({dealers, extra, message, wrapper}, formID) {
		const $container = $('#dealer-results-' + formID);
		const $form = $container.parents('.nf-form-layout').find('form');
		const $errorField = $('.nf-field:has(#dealer-results-' + formID + ')');

		if ($container.length) {
		  $container.removeClass('js-slider');

		  if ($container.hasClass('slick-initialized')) {
		    $container.slick('unslick');
		  }

		  $container.empty();

		  $('.dealers-message, #dealer-results-' + formID + ' .nf-spinner').remove();
		  $('#dealer-more-info .more-info-content').empty();
		  $('.fallback-form').hide();
		} else {
		  $('.find-dealer-submit').parents('.nf-form-cont').after('<div id="dealer-results-' + formID + '" class="wp-block-columns"></div>');
		}

		if (dealers.length > 0) {
		  	for (var i = dealers.length - 1; i >= 0; i--) {
			    $container.prepend(dealers[i]);

			    if (message != '' && $('.dealers-message').length == 0) {
			    	$container.before('<div class="dealers-message">'+ message + '</h4>');
			    }
			    
			    $('#dealer-more-info .more-info-content').prepend(extra[i]);

			    if (message != '') {
			    	$('.fallback-form').fadeIn();
			    }
		  	}

		  	if ($form.length) {
			  	if (!$form.find('.clickable.focused').length &&
	                          $form.find('.clickable').length) {

			  	    $form.find('.nf-next, input[type="submit"]').prop('disabled', true);

			  	    // Add error class and message
			  	    if (!$errorField.find('.nf-error-msg').length) {
			  	      $errorField.addClass('nf-error');
			  	      $errorField.find('.nf-field-element').after('<div class="nf-error-msg">Please select a contractor from whom you would like to request a quote.</div>');
			  	    }
			  	    
			  	}

			  	if (wrapper != "false" && dealers.length > 1) {

			  		if (!$container.hasClass('js-slider')) {
			  		  $container.addClass('js-slider');
			  		}	  			
			  		
			  	} else {
			  		if ($container.hasClass('slick-initialized')) {
			  		  $container.slick('unslick');
			  		  $container.removeClass('js-slider');
			  		}		  		
			  	}			  
		  	}

		  	setTimeout(function() {
		  	  $('.js-slider').not('.slick-initialized').slick({
		  	      slidesToScroll: 1,
		  	      arrows: false,
		  	      dots: true,
		  	      infinite: false,
		  	      mobileFirst: true,
		  	      variableWidth: true,
		  	      rows: 0,
		  	      responsive: [
		  	          {
		  	              breakpoint: 800,
		  	              settings: {
		  	                  arrows: true
		  	              }
		  	          }
		  	      ]
		  	  });
		  	}, 600);

		} else {
			// For Dealers Block only (not shortcode)
			if (message != '' && $form.find('.dealers-message').length == 0) {
				$container.before('<div class="dealers-message">'+ message + '</h4>');
			}

			if ($('.fallback-form').length) {
				$('.fallback-form').fadeIn();
			} else {
				var point = JSON.parse(localStorage.getItem('userLatLng'));
				this.matchDealertoAddress(point);
			}

		}
	}

	matchDealertoAddress(point = JSON.parse(localStorage.getItem('userLatLng'))) {
		var local = [];
		var _this = this;

 		$.ajax({
		  method: 'POST',
		  url: ajax_url,
		  type: 'JSON',
		  data: {
		    point: point,
		    action: 'find_local_dealer',
		  },
		  success: localDealer => _this.assignLocalDealerInputs(localDealer),
		  error: function (request, status, error) {
		          console.log(request.responseText);
		      }
		});

	}

	assignLocalDealerInputs(localDealer) {

	    const { name: dealer, email, phone } = localDealer;

	    const $dealerName  = $('[data-key=dealername]').length
	        ? $('[data-key=dealername]')
	        : $('[data-key=dealername_partial]');

	    const $dealerEmail = $('[data-key=dealeremail]').length
	        ? $('[data-key=dealeremail]')
	        : $('[data-key=dealeremail_partial]');

	    const $dealerPhone = $('[data-key=dealerphone]').length
	        ? $('[data-key=dealerphone]')
	        : $('[data-key=dealerphone_partial]');

	    $dealerName.val(dealer).trigger('change');
	    $dealerEmail.val(email).trigger('change');
	    $dealerPhone.val(phone).trigger('change');

	    // Native event fallback (if Ninja Forms still ignores jQuery trigger)
	    [$dealerName[0], $dealerEmail[0], $dealerPhone[0]].forEach(el => {
	        if (el) el.dispatchEvent(new Event('change', { bubbles: true }));
	    });

	    console.log(dealer);

	    if ($('.dealers-message').has('.nothing-found').length) {
	        $('.nf-form-layout')
	            .has('.dealers-message')
	            .find('.nf-next, input[type="submit"]')
	            .prop('disabled', false);
	    }
	}

}
export default geoDealers;